/*
 * @Author: dingguowei
 * @Date: 2023-05-18 11:26:03
 * @LastEditors: dingguowei
 * @LastEditTime: 2023-05-29 16:12:28
 */
import request from '@/plugins/axios'
const base = '/'

export function getXhm(params) {
  return request({
    url: base + 'api/jd/xhm/lg/get',
    method: 'get',
    params
  })
}

export function getV2Xhm(params) {
  return request({
    url: base + 'api/jd/xhm/lg/v2/get',
    method: 'get',
    params
  })
}

export function getMxXhm(params) {
  return request({
    url: base + 'api/jd/xhm/mx/get',
    method: 'get',
    params
  })
}